import { useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { putData } from "../../../API";

function  CategoryEdit({ editableData, setEditShow, fetchData }) {
  const initialValues = {
    rtId: editableData?.rtId || 0,
    categoryName: editableData?.categoryName || "",
    isActive: editableData?.isActive ?? true,
  };

  const validationSchema = Yup.object().shape({
    categoryName: Yup.string().required("Category Name is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await putData("RateCategory/UpdateCategories", values);
      if (res.statusCode === 200) {
        toast.success("Category updated successfully!", { autoClose: 5000 });
        fetchData();
        setEditShow(false);
      } else {
        toast.error(res.message || "Failed to update category", { autoClose: 5000 });
      }
    } catch (err) {
      toast.error("Something went wrong", { autoClose: 5000 });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, setFieldValue, isSubmitting }) => (
        <FormikForm>
          <div className="d-flex row justify-content-between m-4">
            <Form.Group className="col-md-6">
              <Form.Label>
                Category Name <span className="text-danger">*</span>
              </Form.Label>
              <Field name="categoryName">
                {({ field, meta }) => (
                  <>
                    <Form.Control
                      type="text"
                      placeholder="Enter Category Name"
                      isInvalid={meta.touched && meta.error}
                      {...field}
                    />
                    <Form.Control.Feedback type="invalid">
                      {meta.error}
                    </Form.Control.Feedback>
                  </>
                )}
              </Field>
            </Form.Group>

            <Form.Group className="col-md-6">
              <Form.Label>Status</Form.Label>
              <div className="row d-flex justify-content-center align-items-center">
                <Form.Check
                  className="col-md-6"
                  type="radio"
                  label="Active"
                  name="isActive"
                  id="isActiveTrue"
                  checked={values.isActive === true}
                  onChange={() => setFieldValue("isActive", true)}
                />
                <Form.Check
                  className="col-md-6"
                  type="radio"
                  label="Inactive"
                  name="isActive"
                  id="isActiveFalse"
                  checked={values.isActive === false}
                  onChange={() => setFieldValue("isActive", false)}
                />
              </div>
            </Form.Group>
          </div>

          <div style={{ textAlign: "center", margin: "4px" }}>
            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              SUBMIT
            </Button>
          </div>
        </FormikForm>
      )}
    </Formik>
    <ToastContainer />
    </>
  );
}

export default CategoryEdit;
